

























































import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import { sleep, shuffle } from "../utils";
import * as api from '../api'
import App from '../App'
import { remoteOp } from "../helper";
import format from '../format'
import { toast } from "../ui";

interface UnsetState {
  kind: 'unset';
}

interface ErrorState {
  kind: 'error';
  message: string;
}

interface DoneState {
  kind: 'done';
  items: any[];
  columns: {name: string, label: string}[]
}

type State = UnsetState | ErrorState | DoneState

@Component({
  filters: {
    datetime(value: number) {
      let o = new Date(value * 1000)
      return format(o, 'Y-m-d H:i')
    }
  }
})
export default class UniFormList extends Vue {

  state: State = {kind: 'unset'}

  loading = false

  busy = false

  type = ''

  title = ''

  get status() {
    return this.state.kind
  }

  getViewLink(id: number) {
    let router = this.$router
    let route = this.$route
    let location = {
      name: 'uniForm-view',
      params: {id: id.toString()}
    }
    return router.resolve(location, route).href
  }

  get items(): ReadonlyArray<any> {
    if (this.state.kind === 'done') {
      let state = this.state
      return state.items
    }
    else
      throw new Error('runtime error.')
  }

  get columns(): ReadonlyArray<any> {
    if (this.state.kind === 'done') {
      let state = this.state
      return state.columns
    }
    else
      throw new Error('runtime error.')
  }

  created() {
    this.reset()
  }

  @Watch('$route')
  $routeChanged() {
    if (this.$route.params.type !== this.type) {
      this.reset()
    }
  }

  async reset() {
    await sleep(0)
    this.type = this.$route.params.type
    let x = (this.$root.$children[0] as App).uniForms.find(v => v.type == this.type)
    if (x) {
      this.title = x.title
    }
    this.loading = true
    try {
      let result = await api.invoke('uniForm/ls', this.$route.params.type)
      this.state = {
        kind: 'done',
        items: result.items,
        columns: result.columns,
      }
      this.loading = false
    }
    catch (e) {
      this.state = {kind: 'error', message: (e as Error).message}
      this.loading = false
    }
  }

  async remove(event: MouseEvent, id: number) {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    let app = this.$root.$children[0] as App
    let el = event.srcElement!.parentElement!.parentElement!
    if (await app.exposeAndConfirm(el, '删除操作不可恢复, 是否继续?')) {
      remoteOp(this, '删除', '', async () => {
        await api.invoke('uniForm/delete', id)
        let index = state.items.findIndex(n=>n.id == id)
        if (index !== -1)
          state.items.splice(index, 1)
      }, 880)
    }
  }
}
